module.exports = __webpack_public_path__ + "img/reminder.64b6899d.png";